module.exports = __webpack_public_path__ + "static/media/3.103c0884.jpg";